export default function CharteModeration() {
  return (
    <div className="container mb-5 px-3 px-md-4" style={{ maxWidth: '800px' }}>

      <h1 className="mb-2 text-center" style={{ fontSize: 'clamp(1.3rem, 5vw, 2rem)', fontWeight: 700 }}>
        Charte de Bonne Conduite
      </h1>
      <p className="text-center text-muted mb-4" style={{ fontSize: '0.85rem' }}>
        Dernière mise à jour : juin 2025
      </p>

      {/* ── Intro ────────────────────────────────────────────────────────── */}
      <section className="mb-4 p-3 rounded" style={{
        background: '#e8f8f5', border: '1px solid #07a993',
        borderRadius: '12px', fontSize: '0.9rem',
      }}>
        <p className="mb-0">
          SpotyPark repose sur la <strong>confiance mutuelle</strong> entre acheteurs et vendeurs.
          Cette charte définit les règles de bonne conduite que chaque utilisateur s'engage
          à respecter. Tout manquement peut entraîner des sanctions allant jusqu'à la
          suppression définitive du compte.
        </p>
      </section>

      {/* ── Devoirs acheteurs ────────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{
          fontSize: '1.1rem', fontWeight: 700,
          padding: '10px 14px', borderRadius: '8px',
          background: '#0d6efd', color: '#fff', marginBottom: '16px',
        }}>
          🛒 Devoirs des Acheteurs
        </h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>

          {/* Ponctualité */}
          <div className="p-3 rounded" style={{
            border: '1px solid #dee2e6', background: '#fff',
            borderLeft: '4px solid #0d6efd',
          }}>
            <div style={{ fontWeight: 700, marginBottom: '6px', fontSize: '0.92rem' }}>
              ⏰ Ponctualité
            </div>
            <p style={{ fontSize: '0.85rem', marginBottom: 0, color: '#555' }}>
              L'acheteur s'engage à se présenter à l'heure convenue lors de la réservation.
              Tout retard doit être signalé au vendeur via la messagerie de l'application.
            </p>
          </div>

          {/* Annulation */}
          <div className="p-3 rounded" style={{
            border: '1px solid #dee2e6', background: '#fff',
            borderLeft: '4px solid #0d6efd',
          }}>
            <div style={{ fontWeight: 700, marginBottom: '10px', fontSize: '0.92rem' }}>
              ❌ Politique d'annulation
            </div>
            <div className="table-responsive">
              <table className="table table-sm table-bordered mb-0" style={{ fontSize: '0.85rem' }}>
                <thead className="table-light">
                  <tr>
                    <th>Délai avant la réservation</th>
                    <th className="text-center">Remboursement</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Plus de 24h avant</td>
                    <td className="text-center" style={{ color: '#198754', fontWeight: 700 }}>100 %</td>
                  </tr>
                  <tr>
                    <td>Entre 12h et 24h avant</td>
                    <td className="text-center" style={{ color: '#ffc107', fontWeight: 700 }}>50 %</td>
                  </tr>
                  <tr>
                    <td>Moins de 12h avant</td>
                    <td className="text-center" style={{ color: '#dc3545', fontWeight: 700 }}>0 %</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p style={{ fontSize: '0.78rem', color: '#6c757d', marginTop: '8px', marginBottom: 0 }}>
              Toute annulation doit être effectuée via l'application. Aucune annulation
              par téléphone ou message direct ne sera prise en compte.
            </p>
          </div>

          {/* Confirmation de présence */}
          <div className="p-3 rounded" style={{
            border: '1px solid #dee2e6', background: '#fff',
            borderLeft: '4px solid #0d6efd',
          }}>
            <div style={{ fontWeight: 700, marginBottom: '6px', fontSize: '0.92rem' }}>
              ✅ Confirmation de présence
            </div>
            <p style={{ fontSize: '0.85rem', marginBottom: 0, color: '#555' }}>
              À son arrivée sur place, l'acheteur doit confirmer sa présence via le bouton
              <strong> "Présent"</strong> dans l'application. L'heure et la localisation GPS
              sont alors enregistrées et servent de preuve en cas de litige.
            </p>
          </div>

          {/* Signalement */}
          <div className="p-3 rounded" style={{
            border: '1px solid #dee2e6', background: '#fff',
            borderLeft: '4px solid #0d6efd',
          }}>
            <div style={{ fontWeight: 700, marginBottom: '6px', fontSize: '0.92rem' }}>
              🚨 Signalement d'un problème
            </div>
            <p style={{ fontSize: '0.85rem', marginBottom: 0, color: '#555' }}>
              En cas de problème (vendeur absent, place non conforme, place déjà occupée),
              l'acheteur doit utiliser le bouton <strong>"Signaler un imprévu"</strong> dans
              l'application dans les <strong>15 minutes</strong> suivant l'heure convenue.
              Ce signalement déclenche la procédure de litige et le remboursement éventuel.
            </p>
          </div>

          {/* Courtoisie */}
          <div className="p-3 rounded" style={{
            border: '1px solid #dee2e6', background: '#fff',
            borderLeft: '4px solid #0d6efd',
          }}>
            <div style={{ fontWeight: 700, marginBottom: '6px', fontSize: '0.92rem' }}>
              🤝 Respect et courtoisie
            </div>
            <p style={{ fontSize: '0.85rem', marginBottom: 0, color: '#555' }}>
              L'acheteur s'engage à traiter le vendeur avec respect et courtoisie.
              Tout comportement abusif, menaçant ou irrespectueux peut entraîner
              la suspension immédiate du compte.
            </p>
          </div>

        </div>
      </section>

      {/* ── Devoirs vendeurs ─────────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{
          fontSize: '1.1rem', fontWeight: 700,
          padding: '10px 14px', borderRadius: '8px',
          background: '#07a993', color: '#fff', marginBottom: '16px',
        }}>
          💰 Devoirs des Vendeurs
        </h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>

          {/* Disponibilité */}
          <div className="p-3 rounded" style={{
            border: '1px solid #dee2e6', background: '#fff',
            borderLeft: '4px solid #07a993',
          }}>
            <div style={{ fontWeight: 700, marginBottom: '6px', fontSize: '0.92rem' }}>
              ⏳ Disponibilité et ponctualité
            </div>
            <p style={{ fontSize: '0.85rem', marginBottom: 0, color: '#555' }}>
              Le vendeur doit être présent sur la place réservée à l'heure convenue
              et y rester jusqu'à l'arrivée de l'acheteur ou l'expiration du délai de
              signalement (15 minutes). Tout départ anticipé sans annulation préalable
              est considéré comme un manquement.
            </p>
          </div>

          {/* Validation départ */}
          <div className="p-3 rounded" style={{
            border: '1px solid #dee2e6', background: '#fff',
            borderLeft: '4px solid #07a993',
          }}>
            <div style={{ fontWeight: 700, marginBottom: '6px', fontSize: '0.92rem' }}>
              🚗 Validation du départ
            </div>
            <p style={{ fontSize: '0.85rem', marginBottom: 0, color: '#555' }}>
              Le vendeur valide son départ via le bouton <strong>"Départ"</strong> dans
              l'application. Cette action enregistre l'heure et la position GPS,
              confirmant la libération effective de la place.
            </p>
          </div>

          {/* Annulation vendeur */}
          <div className="p-3 rounded" style={{
            border: '1px solid #dee2e6', background: '#fff',
            borderLeft: '4px solid #07a993',
          }}>
            <div style={{ fontWeight: 700, marginBottom: '6px', fontSize: '0.92rem' }}>
              ❌ Annulation par le vendeur
            </div>
            <p style={{ fontSize: '0.85rem', marginBottom: '8px', color: '#555' }}>
              Le vendeur est limité à <strong>5 annulations par jour</strong>.
              Au-delà de ce plafond, son accès à la vente est automatiquement suspendu
              pour une durée de <strong>7 jours</strong>.
            </p>
            <div className="p-2 rounded" style={{
              background: '#fff3cd', border: '1px solid #ffc107',
              fontSize: '0.78rem', color: '#856404',
            }}>
              ⚠️ La suspension n'annule pas l'obligation de paiement de l'abonnement
              en cours. Les annulations effectuées avant l'heure convenue n'entraînent
              pas de pénalité financière pour le vendeur.
            </div>
          </div>

          {/* Exactitude annonce */}
          <div className="p-3 rounded" style={{
            border: '1px solid #dee2e6', background: '#fff',
            borderLeft: '4px solid #07a993',
          }}>
            <div style={{ fontWeight: 700, marginBottom: '6px', fontSize: '0.92rem' }}>
              📍 Exactitude de l'annonce
            </div>
            <p style={{ fontSize: '0.85rem', marginBottom: 0, color: '#555' }}>
              Le vendeur s'engage à renseigner des informations exactes : localisation,
              type de parking, étage, numéro de place. Si la place est dans une zone
              réservée au personnel d'une entreprise ou d'un établissement, il doit
              obligatoirement cocher l'option <strong>"Place réservée au personnel"</strong>{' '}
              afin d'avertir les acheteurs potentiels.
            </p>
          </div>

          {/* Courtoisie vendeur */}
          <div className="p-3 rounded" style={{
            border: '1px solid #dee2e6', background: '#fff',
            borderLeft: '4px solid #07a993',
          }}>
            <div style={{ fontWeight: 700, marginBottom: '6px', fontSize: '0.92rem' }}>
              🤝 Respect et courtoisie
            </div>
            <p style={{ fontSize: '0.85rem', marginBottom: 0, color: '#555' }}>
              Le vendeur s'engage à traiter l'acheteur avec respect. Tout comportement
              abusif ou menaçant peut entraîner la suspension immédiate du compte,
              sans remboursement de l'abonnement en cours.
            </p>
          </div>

        </div>
      </section>

      {/* ── Règles et sanctions ──────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{
          fontSize: '1.1rem', fontWeight: 700,
          padding: '10px 14px', borderRadius: '8px',
          background: '#dc3545', color: '#fff', marginBottom: '16px',
        }}>
          ⚖️ Règles et sanctions
        </h2>

        <div className="table-responsive">
          <table className="table table-bordered table-sm" style={{ fontSize: '0.85rem' }}>
            <thead className="table-light">
              <tr>
                <th>Manquement</th>
                <th>Partie concernée</th>
                <th>Sanction</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Absence non signalée à l'heure convenue</td>
                <td>Vendeur</td>
                <td style={{ color: '#dc3545', fontWeight: 600 }}>Suspension 7 jours + remboursement acheteur 100 %</td>
              </tr>
              <tr>
                <td>Place non conforme à l'annonce</td>
                <td>Vendeur</td>
                <td style={{ color: '#dc3545', fontWeight: 600 }}>Remboursement acheteur 100 % + avertissement</td>
              </tr>
              <tr>
                <td>Dépassement du plafond d'annulations (5/jour)</td>
                <td>Vendeur</td>
                <td style={{ color: '#dc3545', fontWeight: 600 }}>Suspension accès vente 7 jours</td>
              </tr>
              <tr>
                <td>Non-respect répété des engagements</td>
                <td>Vendeur / Acheteur</td>
                <td style={{ color: '#dc3545', fontWeight: 600 }}>Suspension 30 jours ou suppression du compte</td>
              </tr>
              <tr>
                <td>Annulation moins de 12h avant</td>
                <td>Acheteur</td>
                <td style={{ color: '#dc3545', fontWeight: 600 }}>Aucun remboursement</td>
              </tr>
              <tr>
                <td>Faux signalement ou abus de procédure</td>
                <td>Acheteur / Vendeur</td>
                <td style={{ color: '#dc3545', fontWeight: 600 }}>Avertissement puis suspension</td>
              </tr>
              <tr>
                <td>Comportement abusif ou menaçant</td>
                <td>Acheteur / Vendeur</td>
                <td style={{ color: '#dc3545', fontWeight: 600 }}>Suspension immédiate + signalement possible aux autorités</td>
              </tr>
              <tr>
                <td>Fraude, faux compte, manipulation</td>
                <td>Acheteur / Vendeur</td>
                <td style={{ color: '#dc3545', fontWeight: 600 }}>Suppression définitive + signalement aux autorités</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mt-3 p-3 rounded" style={{
          background: '#fff3cd', border: '1px solid #ffc107',
          fontSize: '0.82rem', color: '#856404', borderRadius: '8px',
        }}>
          <strong>📋 Important :</strong> Toutes les actions officielles (confirmation de présence,
          signalement, annulation, validation de départ) doivent être effectuées
          <strong> exclusivement via l'application</strong>. Aucune démarche effectuée
          en dehors de l'application ne pourra être prise en compte en cas de litige.
        </div>
      </section>

      {/* ── Procédure de litige ──────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{
          fontSize: '1.1rem', fontWeight: 700,
          padding: '10px 14px', borderRadius: '8px',
          background: '#ffc107', color: '#000', marginBottom: '16px',
        }}>
          🔍 Procédure de litige
        </h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {[
            { etape: '1', titre: 'Signalement dans l\'app', texte: 'L\'utilisateur lésé utilise le bouton "Signaler un imprévu" dans les 15 minutes suivant l\'heure convenue.' },
            { etape: '2', titre: 'Analyse par SpotyPark', texte: 'SpotyPark examine les données enregistrées (horodatage, GPS, historique) et les éléments fournis par les deux parties.' },
            { etape: '3', titre: 'Décision sous 48h ouvrées', texte: 'Une décision est rendue sous 48 heures ouvrées. Les deux parties sont notifiées par e-mail et via l\'application.' },
            { etape: '4', titre: 'Contestation possible', texte: 'Toute décision peut être contestée en écrivant à support@spotypark.fr dans un délai de 30 jours.' },
          ].map(({ etape, titre, texte }) => (
            <div key={etape} className="d-flex align-items-start gap-3 p-3 rounded" style={{
              border: '1px solid #dee2e6', background: '#fff', borderRadius: '10px',
            }}>
              <div style={{
                minWidth: '32px', minHeight: '32px', borderRadius: '50%',
                background: '#ffc107', color: '#000',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: 700, fontSize: '0.9rem', flexShrink: 0,
              }}>
                {etape}
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: '0.88rem', marginBottom: '4px' }}>
                  {titre}
                </div>
                <p style={{ fontSize: '0.82rem', color: '#555', marginBottom: 0 }}>
                  {texte}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Principes clés ───────────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{
          fontSize: '1.1rem', fontWeight: 700,
          padding: '10px 14px', borderRadius: '8px',
          background: '#1a1a2e', color: '#fff', marginBottom: '16px',
        }}>
          🌟 Principes fondamentaux
        </h2>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
          gap: '12px',
        }}>
          {[
            { icon: '⏰', titre: 'Ponctualité',      texte: 'Respect des horaires convenus par les deux parties.' },
            { icon: '🤝', titre: 'Bonne foi',         texte: 'Engagement sincère et honnête de chaque utilisateur.' },
            { icon: '📱', titre: 'Via l\'app',        texte: 'Toutes les actions officielles se font dans l\'application.' },
            { icon: '💬', titre: 'Courtoisie',        texte: 'Respect mutuel entre acheteurs et vendeurs.' },
            { icon: '🔒', titre: 'Transparence',      texte: 'Des informations exactes pour une communauté de confiance.' },
          ].map(({ icon, titre, texte }) => (
            <div key={titre} className="text-center p-3 rounded" style={{
              background: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '10px',
            }}>
              <div style={{ fontSize: '1.8rem', marginBottom: '8px' }}>{icon}</div>
              <div style={{ fontWeight: 700, fontSize: '0.88rem', marginBottom: '4px' }}>{titre}</div>
              <p style={{ fontSize: '0.78rem', color: '#6c757d', marginBottom: 0 }}>{texte}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── Contact ──────────────────────────────────────────────────────── */}
      <section className="p-3 rounded text-center" style={{
        background: '#e8f8f5', border: '1px solid #07a993', borderRadius: '12px',
      }}>
        <p style={{ fontSize: '0.9rem', marginBottom: '8px' }}>
          Cette charte garantit <strong>sécurité, confiance et équité</strong> pour tous
          les membres de SpotyPark. Merci de la respecter scrupuleusement.
        </p>
        <p style={{ fontSize: '0.85rem', color: '#6c757d', marginBottom: 0 }}>
          Pour toute question : <a href="/contact">Cliquer sur le lien</a>
        </p>
      </section>

    </div>
  );
}